<template>
  <div>
    <input
      ref="input"
      type="hidden"
      :value="value"
      :name="name"
      :id="name"
    />
  </div>
</template>

<script>
export default {
  name: "url-token",
  props: {
    name: {
      type: String,
      required: true
    },
    prop: {
      type: String,
      default: "code"
    },
    value: {
      required: false
    }
  },
  methods: {
    updateValue (val) {
      this.$emit("component-updated", {
        text: val
      });
      this.$emit("input", val);
    }
  },
  mounted () {
    this.updateValue(this.$route.query[this.prop]);
  }
};
</script>
